export default {
  API_BASE_URL: '/api/v1/',
  SITE_BASE_URL: '/',
  SITE_DATA_URL: '/',
  IMG_ASSETS_PATH: '/produkty/assets/img/',
  GA_TAG_ID: 'UA-307719-1',
}
